import React, { useState } from 'react';
import ManageSubscriptionModal from './ManageSubscriptionModal';

const FEATURE_LABELS = {
  artHistoryAppreciation: 'Art History Appreciation',
  artComparison: 'Art History Compare',
  styleTransfer: 'Style Transfer',
  dailyActivities: 'Daily Activities',
  individualArtAppreciation: 'Individual Art Appreciation',
  coLearningSpace: 'Co-Learning Space',
  reimagineStudio: 'Reimagine Studio',
  storyboarding: 'Storyboarding Studio',
};

export default function UpgradeQuotaModal({ open, isOpen, onClose, feature, onUpgrade }) {
  const [showManageSubscription, setShowManageSubscription] = useState(false);
  const showUpgradePopup = open ?? isOpen;
  // Keep this component mounted while ManageSubscriptionModal is open.
  const visible = showUpgradePopup || showManageSubscription;
  if (!visible) return null;

  const featureLabel = FEATURE_LABELS[feature] || 'this feature';
  const isProOnly = feature === 'storyboarding';
  const isArtHistory = feature === 'artHistoryAppreciation';
  const isStyleTransfer = feature === 'styleTransfer';

  const handleUpgrade = () => {
    // Close the quota popup overlay, but keep this component mounted
    // so ManageSubscriptionModal can render.
    onClose?.();
    if (onUpgrade) {
      onUpgrade();
      return;
    }
    setShowManageSubscription(true);
  };

  const handleMaybeLater = () => {
    // Always close every layer and keep the user on the same screen.
    setShowManageSubscription(false);
    onClose?.();
  };

  const title = isProOnly
    ? 'Pro feature'
    : isArtHistory
      ? 'Art History Exploration limit reached'
      : (isStyleTransfer ? 'Style Transfer & Tutorial limit reached' : 'Monthly quota used');
  const message = isProOnly
    ? <><strong>{featureLabel}</strong> is available for Pro users. Upgrade to Pro to access.</>
    : isArtHistory
      ? <>You have exhausted your quota for the Base plan. For unlimited access to wonderful art adventures, upgrade to Pro.</>
      : isStyleTransfer
        ? <>You&apos;ve exhausted your Style Transfer artwork quota for this period. Each artwork allows up to 3 styles (with tutorials). Upgrade to Pro for unlimited.</>
        : <>You have utilized the quota for the month for <strong>{featureLabel}</strong>. Upgrade to Pro for unlimited access.</>;

  return (
    <>
      {showUpgradePopup && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-[radial-gradient(circle_at_20%_20%,rgba(251,191,36,0.24),transparent_45%),radial-gradient(circle_at_80%_80%,rgba(56,189,248,0.16),transparent_42%),rgba(17,24,39,0.52)] backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 text-center border-2 border-amber-200">
            <div className="text-4xl mb-3">✨</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              {title}
            </h3>
            <p className="text-gray-700 mb-4">
              {message}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                type="button"
                onClick={handleUpgrade}
                className="px-5 py-2.5 rounded-xl font-semibold bg-amber-500 hover:bg-amber-600 text-white transition-colors"
              >
                Upgrade to Pro
              </button>
              <button
                type="button"
                onClick={handleMaybeLater}
                className="px-5 py-2.5 rounded-xl font-semibold bg-gray-100 hover:bg-gray-200 text-gray-800 transition-colors"
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      )}
      <ManageSubscriptionModal
        isOpen={showManageSubscription}
        onClose={() => setShowManageSubscription(false)}
      />
    </>
  );
}
